<template lang="html">
  <section class="juegos-juntas-resultados">
    <div
      class="resultados-juegos-juntas container letter-items flex wrap justify-start"
    >
      <div class="box-result">
        <a
          class="document-el"
           :href="getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.bombasAgua_enlace`)"
          target="_blank"
          >{{ $t("catalogo.cat_juegoJuntas.descarga_juegos.bombasAgua") }}</a
        >
        <a
          class="document-el"
          :href="getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.bombasCombustible_enlace`)"
          target="_blank"
          >{{
            $t("catalogo.cat_juegoJuntas.descarga_juegos.bombasCombustible")
          }}</a
        >
        <a
          class="document-el"
          :href=" getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.bombaHidraulica_enlace`)"
          target="_blank"
          >{{
            $t("catalogo.cat_juegoJuntas.descarga_juegos.bombaHidraulica")
          }}</a
        >
        <a
          class="document-el"
          :href="getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.bombaInyeccion_enlace`)"
          target="_blank"
          >{{
            $t("catalogo.cat_juegoJuntas.descarga_juegos.bombaInyeccion")
          }}</a
        >
        <a
          class="document-el"
          :href=" getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.bombaVacio_enlace`)"
          target="_blank"
          >{{ $t("catalogo.cat_juegoJuntas.descarga_juegos.bombaVacio") }}</a
        >
      </div>

      <div class="box-result">
        <a
          class="document-el"
          :href=" getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.juntaCarter_enlace`)"
          target="_blank"
          >{{ $t("catalogo.cat_juegoJuntas.descarga_juegos.juntaCarter") }}</a
        >
        <a
          class="document-el"
          :href=" getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.colectorAdminision_enlace`)"
          target="_blank"
          >{{
            $t("catalogo.cat_juegoJuntas.descarga_juegos.colectorAdminision")
          }}</a
        >
        <a
          class="document-el"
          :href=" getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.colectorEscape_enlace`)"
          target="_blank"
          >{{
            $t("catalogo.cat_juegoJuntas.descarga_juegos.colectorEscape")
          }}</a
        >
        <a
          class="document-el"
          :href=" getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.comprensor_enlace`)"
          target="_blank"
          >{{ $t("catalogo.cat_juegoJuntas.descarga_juegos.comprensor") }}</a
        >
        <a
          class="document-el"
          :href=" getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.inyector_enlace`)"
          target="_blank"
          >{{ $t("catalogo.cat_juegoJuntas.descarga_juegos.inyector") }}</a
        >
      </div>
      <div class="box-result">
        <a
          class="document-el"
          :href=" getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.radiadorAceite_enlace`)"
          target="_blank"
          >{{
            $t("catalogo.cat_juegoJuntas.descarga_juegos.radiadorAceite")
          }}</a
        >
        <a
          class="document-el"
          :href=" getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.sistemaEscape_enlace`)"
          target="_blank"
          >{{ $t("catalogo.cat_juegoJuntas.descarga_juegos.sistemaEscape") }}</a
        >
        <a
          class="document-el"
          :href=" getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.sistemaEGR_enlace`)"
          target="_blank"
          >{{ $t("catalogo.cat_juegoJuntas.descarga_juegos.sistemaEGR") }}</a
        >
        <a
          class="document-el"
          :href=" getServer + $t(`catalogo.cat_juegoJuntas.descarga_juegos.tapasCulata_enlace`)"
          target="_blank"
          >{{ $t("catalogo.cat_juegoJuntas.descarga_juegos.tapasCulata") }}</a
        >
      </div>
    </div>
  </section>
</template>

<script lang="js">
import {mapGetters} from 'vuex';
    export default  {
      name: 'juegos-juntas-resultados',
      props: [],
      mounted() {

      },
      data() {
        return {

        }
      },
      methods: {

      },
      computed: {
        ...mapGetters(['getServer', 'getLanguage']),
      }
  }
</script>

<style scoped>
  .document-el {
    color: #054279;
    margin-top: 3px;
    padding-left: 40px;
    background: url(/static/img/archive.svg) center left/23px no-repeat;
    text-transform: uppercase;
    width: 100%;
    height: 30px;
    line-height: 30px;
    background-size: contain;
  }
  .resultados-juegos-juntas .box-result {
    width: 33.3%;
    width: 33.3%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding-right: 15px;
  }
  .resultados-juegos-juntas {
    margin-top: 40px;
    padding: 0 50px 0 128px;
  }
  .resultados-juegos-juntas.letter-items a {
    text-align: left;
  }
  @media screen and (max-width: 1025px) {
    .resultados-juegos-juntas[data-v-2c8fe1b1] {
      margin-top: 40px;
      padding: 0 50px;
    }
  }
  @media screen and (max-width: 800px) {
    .resultados-juegos-juntas .box-result {
      width: 50%;
    }
    .resultados-juegos-juntas .box-result:nth-child(1) {
      order: 1;
    }
    .resultados-juegos-juntas .box-result:nth-child(2) {
      order: 3;
    }
    .resultados-juegos-juntas .box-result:nth-child(3) {
      order: 2;
    }
    .resultados-juegos-juntas {
      padding: 0 40px;
    }
  }
  @media screen and (max-width: 600px) {
    .resultados-juegos-juntas .document-el {
      width: 100%;
      color: #054279;
      margin-top: 3px;
      padding-left: 40px;
      background: url(/static/img/archive.svg) center left/23px no-repeat;
      text-transform: uppercase;
      height: 40px;
      line-height: 23px;
      background-size: contain;
      display: flex;
      align-items: flex-end;
    }
    .resultados-juegos-juntas[data-v-2c8fe1b1] {
      margin-top: 15px;
      padding: 0 20px;
    }
    .resultados-juegos-juntas .box-result {
      width: 100%;
    }
     .resultados-juegos-juntas .box-result:nth-child(2) {
      order: 2;
    }
    .resultados-juegos-juntas .box-result:nth-child(3) {
      order: 3;
    }
    .resultados-juegos-juntas {
      padding: 0 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/view-parts/catalogo-parts/juegos-juntas-resultados.vue